import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';
import { getContractAddress } from 'utilities';
import config from 'config';
import dlVaultAbi from 'constants/contracts/abis/dlVault.json';

import { BscChainId } from 'types';

export interface MintUmiInput {
  userSigner: ethers.Signer;
  InviterReward?: string;
  amountWei: BigNumber;
  umiamountWei: BigNumber;
  chainId?: BscChainId;
}

export interface MintUmiOutput {
  success: boolean;
  txHash?: string;
  error?: string;
}

const mintUmi = async ({
  userSigner,
  InviterReward = '0x0000000000000000000000000000000000000000',
  amountWei,
  umiamountWei,
  chainId = config.chainId,
}: MintUmiInput): Promise<MintUmiOutput> => {
  try {
    const userAddress = await userSigner.getAddress();
    const dlVault = new ethers.Contract(
      getContractAddress('dlVault'),
      dlVaultAbi,
      userSigner,
    );

    const tx = await dlVault.deposit(
      amountWei.toFixed(),
      umiamountWei.toFixed(),
      InviterReward,
      { from: userAddress },
    );
    await tx.wait();

    return {
      success: true,
      txHash: tx.hash,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
};

export default mintUmi;
